/**
 * Check if the app is running as an installed PWA (standalone mode)
 */
export function isRunningAsPWA(): boolean {
  // Check display-mode: standalone (works on most browsers)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

  // iOS Safari specific check
  const isIOSPWA = (navigator as unknown as { standalone?: boolean }).standalone === true;

  return isStandalone || isIOSPWA;
}

/**
 * Get the platform/OS the app is running on
 */
export function getPlatform(): string {
  const ua = navigator.userAgent;

  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/Windows/.test(ua)) return 'windows';
  if (/Mac/.test(ua)) return 'macos';
  if (/Linux/.test(ua)) return 'linux';
  if (/CrOS/.test(ua)) return 'chromeos';

  return 'unknown';
}
